import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TooltipModule, TooltipOptions } from '@cloudfactorydk/ng2-tooltip-directive';
import { IonicModule } from '@ionic/angular';


import { CoverThumbnailComponent } from "../../components/cover-thumbnail/cover-thumbnail.component";
import { DefaultTooltipOptions } from '../default-tooltip-options';
import { LaminationOptionsComponent } from "../lamination-options/lamination-options.component";
import { BindingOptionsComponent } from './binding-options.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    IonicModule,
    TooltipModule.forRoot(DefaultTooltipOptions as TooltipOptions),
    LaminationOptionsComponent,
  ],
  exports: [BindingOptionsComponent, CoverThumbnailComponent],
  declarations: [BindingOptionsComponent, CoverThumbnailComponent]
})
export class BindingOptionsModule {
}
